<template>
  <div class="modal bg-opacity-50 bg-black" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            Character Audit Logs (<em>{{ this.data.entity.name }}</em>)
          </h5>
          <span aria-hidden="true" role="button" @click="close"><i class="fas fa-xmark"></i></span>
        </div>
        <div class="modal-body">
          <div class="container my-3">
            <div class="d-flex flex-wrap gap-2 px-4 py-4" role="group" aria-label="Basic example">
              <button type="button" class="btn btn-outline-primary" :class="{ active: this.auditFilter.type === value }"
                v-for="(value, key) of auditType" :key="key" @click="setCurrentAuditType(value)">
                {{ key }}
              </button>
            </div>
            <Spinner v-if="this.isLoading">Gettings Logs</Spinner>
            <div class="text-center" v-show="!this.isLoading">
              <h2>
                {{
                  Object.keys(auditType).find(
                    (key) => auditType[key] === this.auditFilter.type
                  )
                }}
              </h2>
            </div>

            <div>
              <data-table2 :readonly="this.isLoading" v-show="!this.isLoading" :api="getAuditLogs" :actions="actions"
                :headers="headers" :fields="['id']" :mainfilter="this.auditFilter" :trigger="trigger" :showSearch="false" />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="close">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DataTable2 from "./DataTable/DataTable2.vue";
  import Spinner from "./Loaders/Spinner.vue";
  import store from "node-back-client/src/store";
  export default {
    name: "CharacterAuditLogs",
    data() {
      return {
        trigger: {},
        store: store,
        headers: {
          id: "ID",
          equipment_name: "Equipment Name",
          CreatedAt: "Created Date",
        },
        actions: [],
        isLoading: false,
        auditFilter: {
          type: 0,
          character_id: null,
        },
        auditType: {
          Buy: 0,
          Loot: 1,
          Trade: 2,
          Upgrade: 3,
          Quest: 4,
          Vendor: 5,
          Drop: 6,
          PutLocker: 7,
          GetLocker: 8,
          FreshLoot: 9,
          Reward: 10,
          Dupli: 11,
          Craft: 12,
          Recipe: 13,
          Sell: 14,
          FailedUpgrade: 15,
          DestroyedUpgrade: 16,
          Winnable: 17,
          GoldTrade: 18,
        },
      };
    },
    props: {
      data: {
        entity: Object,
        show: Boolean,
      },
      api: Object,
      server: Number,
    },
    components: {
      DataTable2,
      Spinner,
    },
    methods: {
      close() {
        let data = this.data;
        data.show = false;
      },
      async getAuditLogs(filter = {}, skip = 0, limit = 10) {
        try {
          console.log(filter)
          this.isLoading = true;
          this.auditFilter.character_id = this.data.entity.id;
          let page = skip || 0;
          let pageSize = limit || 10;
          const auditLogsData = await this.api.auditLogs.getAuditLogs(
            this.server,
            this.auditFilter,
            page,
            pageSize
          );


          for (const log of auditLogsData.data) {
            const date = new Date(log.CreatedAt);
            log.createdDate = date.toLocaleDateString();
            log.equipment_name = ""
            const charEquipment = await this.api.charequipment.getEquipments(
              this.data.entity.id,
              this.server,
              { _id: log.equipment_id },
              0,
              1
            );
            if (charEquipment.count > 0) {
              log.equipment_name = store.custom.equipmentList.find(item => item.id == charEquipment.data[0].equipment_id).name
            }
          }
          auditLogsData.data.sort((a,b) => new Date(b.CreatedAt) - new Date(a.CreatedAt))
          this.isLoading = false;
          return await auditLogsData;
        } catch (error) {
          console.error(error);
        }
      },
      setCurrentAuditType(type) {
        this.auditFilter.type = type;
        this.trigger.refresh();
      },
    },

    created() {
    },
  };
</script>

<style></style>
